import { route, string } from 'react-router-typesafe-routes/dom';

import { roleplaysRoutes } from 'features/Roleplays';
import { userRoutes } from 'features/User';

export const ROUTES = {
  LANDING: route('landing'),
  HOME: route(''),
  TASK: route('task/:id', {
    params: { id: string().defined() },
    state: { lessonId: string().defined() },
  }),
  LESSON: route('lesson/:id', { params: { id: string().defined() } }),
  LOGIN: route('login'),
  REGISTRATION: route('registration'),
  FORGOT_PASSWORD: route('forgot-password'),
  CHAT: route('chat/:id', { params: { id: string().defined() } }),
  // Onboarding flow routes
  ONBOARDING: {
    NAME: route('onboarding/name'),
    INDUSTRY: route('onboarding/industry'),
    ROLE: route('onboarding/role'),
    EMAIL: route('onboarding/email'),
    CREATING_ACCOUNT: route('onboarding/creating-account'),
  },
  ...roleplaysRoutes,
  ...userRoutes,
};
